import React from "react";
import { Box, Flex, Gap, Icon, Typography } from "../../../../ppui";
import { OrganizationBx, OrganizationEmDetails } from "../../../style";
import {
  TbBriefcase,
  TbBuilding,
  TbCalendar,
  TbCalendarTime,
  TbClock,
  TbDeviceDesktop,
  TbDoorExit,
  TbIdBadge,
  TbSun,
  TbUserCheck,
} from "react-icons/tb";

const JobDescription = () => {
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Job Description
        </Typography>
        {/* <FabButton
          size="sm"
          icon={<TbCopy />}
          // onClick={AboutMeModalOpen}
          variant="filled"
          shape="box"
        /> */}
      </Flex>
      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Icon size={"lg"}>
            <TbCalendarTime />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Joining Date
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              14-12-2024
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbBriefcase />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Employment Type
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Fulltime
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbUserCheck />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Employment Status
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Permanent
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbClock />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Provision Period Days
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              48
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbCalendar />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Contract Duration
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              15-11-2024
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbBuilding />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Branch Name
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              New York
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbDeviceDesktop />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Department
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              IT
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbIdBadge />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Designation
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Software Engineer
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbDoorExit />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Date of Exit
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              10-05-2028
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbSun />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Assigned Shift
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Day
            </Typography>
          </Box>
        </OrganizationBx>
      </OrganizationEmDetails>
    </>
  );
};

export default JobDescription;
